<div class="dialog">
  <app-loading-indicator></app-loading-indicator>
  <h1>Authentication</h1>

  <p>Waiting for authentication. If the process did not start, click the button below.</p>

  <button
    appButton
    name="restart"
    location="box-auth-dialog"
    (click)="openBoxAuthWindow()"
    color="primary"
    spacing="full"
    size="3"
    height="4"
    shape="round"
  >
    Restart
  </button>
</div>
